(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"], input[name="currency_code"]'),
        button: this.querySelector('.localization-selector'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && !this.contains(event.relatedTarget) && !event.relatedTarget.classList.contains('disclosure__link');
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  // Mobile-only footer accordions (single open like Nike)
  (function () {
    const root = document.querySelector("footer.footer");
    if (!root) return;

    const accordions = Array.from(root.querySelectorAll(".js-footer-acc"));
    if (!accordions.length) return;

    const isMobile = () => window.matchMedia("(max-width: 749px)").matches;

    function closeAcc(acc) {
      acc.classList.remove("is-open");
      const btn = acc.querySelector(".js-footer-acc-btn");
      const panel = acc.querySelector(".js-footer-acc-panel");
      if (!btn || !panel) return;

      btn.setAttribute("aria-expanded", "false");
      panel.setAttribute("aria-hidden", "true");

      // Animate from current height to 0
      panel.style.height = panel.scrollHeight + "px";
      requestAnimationFrame(() => {
        panel.style.height = "0px";
      });
    }

    function openAcc(acc) {
      acc.classList.add("is-open");
      const btn = acc.querySelector(".js-footer-acc-btn");
      const panel = acc.querySelector(".js-footer-acc-panel");
      if (!btn || !panel) return;

      btn.setAttribute("aria-expanded", "true");
      panel.setAttribute("aria-hidden", "false");

      // Animate to exact height, then set to auto
      const target = panel.scrollHeight;
      panel.style.height = target + "px";

      const onEnd = (e) => {
        if (e.propertyName !== "height") return;
        panel.style.height = "auto";
        panel.removeEventListener("transitionend", onEnd);
      };
      panel.addEventListener("transitionend", onEnd);
    }

    function toggleAcc(clicked) {
      if (!isMobile()) return;

      const isOpen = clicked.classList.contains("is-open");

      // Close all others (Nike behavior)
      accordions.forEach((acc) => {
        if (acc !== clicked) closeAcc(acc);
      });

      if (isOpen) {
        closeAcc(clicked);
      } else {
        const panel = clicked.querySelector(".js-footer-acc-panel");
        if (panel && panel.style.height === "auto") panel.style.height = "0px";
        openAcc(clicked);
      }
    }

    // Init
    accordions.forEach((acc) => {
      const btn = acc.querySelector(".js-footer-acc-btn");
      const panel = acc.querySelector(".js-footer-acc-panel");
      if (!btn || !panel) return;

      // Start closed on mobile; let desktop be normal
      btn.setAttribute("aria-expanded", "false");
      panel.setAttribute("aria-hidden", "true");
      panel.style.height = isMobile() ? "0px" : "auto";

      btn.addEventListener("click", () => toggleAcc(acc));
    });

    // Resize handling so desktop doesn't break
    window.addEventListener("resize", () => {
      if (!isMobile()) {
        accordions.forEach((acc) => {
          acc.classList.remove("is-open");
          const btn = acc.querySelector(".js-footer-acc-btn");
          const panel = acc.querySelector(".js-footer-acc-panel");
          if (btn) btn.setAttribute("aria-expanded", "false");
          if (panel) {
            panel.setAttribute("aria-hidden", "false");
            panel.style.height = "auto";
          }
        });
      } else {
        accordions.forEach((acc) => {
          const btn = acc.querySelector(".js-footer-acc-btn");
          const panel = acc.querySelector(".js-footer-acc-panel");
          if (!acc.classList.contains("is-open")) {
            if (btn) btn.setAttribute("aria-expanded", "false");
            if (panel) {
              panel.setAttribute("aria-hidden", "true");
              panel.style.height = "0px";
            }
          }
        });
      }
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  let items = document.querySelectorAll(".menu-block");
  let preBlur = document.querySelector(".pre-blur");
    items.forEach(item => {
      item.addEventListener("mouseover", () => {
        item.classList.add("is-focused");
        preBlur.classList.add("is-open");
        item.addEventListener("mouseleave", () => {
          item.classList.remove("is-focused");
          preBlur.classList.remove("is-open");
        });
      item.addEventListener("mouseleave", () => {
        item.classList.remove("is-focused");
        preBlur.classList.remove("is-open");
        });
      });
    });

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.getElementById('shopify-section-header');
    this.header.classList.add('shopify-section-header-sticky');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    this.currentScrollTop = scrollTop;
  }
  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}
customElements.define('sticky-header', StickyHeader);

// element.classList.contains("active");
// preBlur.classList.add("is-open");


  } catch(e) { console.error(e); }
})();
})();
